import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule } from '../../../../../cms-structure/page';
import { I18nModule } from '../../../../../core/i18n';
import {
  CatalogArticleListModule,
  GenericLinkModule,
  MediaModule,
  NavSideScrollModule,
  PipesModule,
  SpinnerModule,
} from '../../../../../shared';
import { LoadMoreComponent } from '../../../../../shared/components/load-more/load-more.component';
import { AssortmentTableModule } from '../../assortment-table';
import { TechnicalAttributesTableModule } from '../../technical-attributes-table';
import { PdpSkuPickerTabsComponent } from './pdp-sku-picker-tabs.component';

@NgModule({
  declarations: [PdpSkuPickerTabsComponent],
  exports: [PdpSkuPickerTabsComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    MediaModule,
    PipesModule,
    NgbNavModule,
    GenericLinkModule,
    LoadMoreComponent,
    AssortmentTableModule,
    TechnicalAttributesTableModule,
    NgbTooltipModule,
    CatalogArticleListModule,
    NavSideScrollModule,
    PageComponentModule,
    SpinnerModule,
  ],
  providers: [],
})
export class PdpSkuPickerTabsModule {}
